import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import LoadingPage from "../../../Components/layouts/loading";
import { labourTrainingInfo } from "../../../SchemaInfo/info";
import FormSubmitButton from "../../../Components/layouts/formSubmitButton";
import SimpleButton from "../../../Components/layouts/simple_button";
import { Formik, Form, FieldArray } from "formik";
import CustomInput from "../../../CustomComponent/custom_input";
import CustomSelect from "../../../CustomComponent/custom_select";
import Footer from "../../../Components/Footer/footer";
import { Toast } from "../../../CustomComponent/toast";
import performRequest from "../../../api/request";
import { FcReadingEbook } from "react-icons/fc";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { labourTrainingSchema } from "../../../Schemas/labour training/labourTraining";
import { getId } from "../../../Components/Functions/word.fun";
import getFilteredURL from "../../../Components/Functions/filters.getUrl";

let trainingData = [
  {
    day: "Day 1",
    work: "Farm Introduction & Safety , Understanding Hydroponic Systems ",
    activities: [
      "Introduction to NVPH, Fan & Pad, and Nethouse structures",
      "Operate side vents and aluminum shade net systems",
      "Conduct tool handling and safety protocol training (PPE, water, electric)",
      "Perform cleaning and sanitation of grow areas",
      "Re-install weedmat securely across bed areas",
      "Identify components of NFT, Growbags, and Dutch Bucket systems",
      "Assemble NFT flatbed, fix leakages, and ensure proper slope",
      "Cleaning of Netcups",
      "Clean NFT channel tops, sides, and tanks",
      "Replace NFT tank motors",
      "Wash used cocopeat and refill growbags",
      "Fix and align drip pipes; remove and reinstall drip motor",
      "Clean and test 4-way drippers for flow consistency",
    ],
  },
  // {
  //   day: "Day 2",
  //   work: "Understanding Hydroponic Systems",
  //   activities: [
  //     "Identify components of NFT, Growbags, and Dutch Bucket systems",
  //     "Assemble NFT flatbed, fix leakages, and ensure proper slope",
  //     "Cleaning of Netcups",
  //     "Clean NFT channel tops, sides, and tanks",
  //     "Replace NFT tank motors",
  //     "Wash used cocopeat and refill growbags",
  //     "Fix and align drip pipes; remove and reinstall drip motor",
  //     "Clean and test 4-way drippers for flow consistency",
  //   ],
  // },
  {
    day: "Day 2",
    work: "Nursery Management , Transplanting & Spacing , Irrigation & Nutrient Management",
    activities: [
      "Prepare dry cocopeat for use (rehydration and buffering if needed)",
      "Wash and sanitize nursery trays",
      "Sow seeds in trays following standard spacing",
      "Maintain nursery environment: watering, shading, temperature management",
      "Tray reusing & Sterlization",
      "Software demo: nursery inventory and seedling status updates",
      "Inspect roots and assess seedlings for transplant readiness",
      "Transplant into NFT channels, Growbags, and Dutch Bucket setups",
      "Clip plants to trellising systems for vining crops",
      "Adjust spacing and support for optimal plant growth",
      "Mix and dose nutrient solution in stock tanks (AB tank method if applicable)",
      "Calibrate and use EC and pH meters; record observations",
      "Set timers and test water flow for both NFT and drip systems",
      "Software demo: input nutrient schedules and log EC/pH readings",
    ],
  },
  // {
  //   day: "Day 4",
  //   work: "Transplanting & Spacing",
  //   activities: [
  //     "Inspect roots and assess seedlings for transplant readiness",
  //     "Transplant into NFT channels, Growbags, and Dutch Bucket setups",
  //     "Clip plants to trellising systems for vining crops",
  //     "Adjust spacing and support for optimal plant growth",
  //   ],
  // },
  {
    day: "Day 3",
    work: "Crop Care & Maintenance , Harvesting & Post-Harvest Handling , Quality Control & Recap",
    activities: [
      "Perform pruning, training, and de-leafing for leafy and vining crops",
      "Identify pests and diseases; introduce IPM methods",
      "Apply drenches or foliar sprays as required",
      "Clean hydroponic systems including channels, drippers, and tanks",
      "Software demo: crop care logging and pest/disease tracking",
      "Check harvest readiness (size, color, weight) for leafy and vining crops",
      "Harvest plants safely using scissors and handling guidelines",
      "Sort, weigh, and record harvested produce",
      "Software demo: enter harvest data, tag batches, prepare for delivery",
      "Conduct quality check for each harvested batch",
      "Verify adherence to SOPs during crop cycle",
      "Conduct group review and quiz or recap session",
      "Software demo: generate reports, review feedback, close batch logs",
    ],
  },
  // {
  //   day: "Day 6",
  //   work: "Crop Care & Maintenance",
  //   activities: [
  //     "Perform pruning, training, and de-leafing for leafy and vining crops",
  //     "Identify pests and diseases; introduce IPM methods",
  //     "Apply drenches or foliar sprays as required",
  //     "Clean hydroponic systems including channels, drippers, and tanks",
  //     "Software demo: crop care logging and pest/disease tracking",
  //   ],
  // },
  // {
  //   day: "Day 4",
  //   work: "Harvesting & Post-Harvest Handling , Quality Control & Recap",
  //   activities: [
  //     "Check harvest readiness (size, color, weight) for leafy and vining crops",
  //     "Harvest plants safely using scissors and handling guidelines",
  //     "Sort, weigh, and record harvested produce",
  //     "Software demo: enter harvest data, tag batches, prepare for delivery",
  //     "Conduct quality check for each harvested batch",
  //     "Verify adherence to SOPs during crop cycle",
  //     "Conduct group review and quiz or recap session",
  //     "Software demo: generate reports, review feedback, close batch logs",
  //   ],
  // },
  // {
  //   day: "Day 8",
  //   work: "Quality Control & Recap",
  //   activities: [
  //     "Conduct quality check for each harvested batch",
  //     "Verify adherence to SOPs during crop cycle",
  //     "Conduct group review and quiz or recap session",
  //     "Software demo: generate reports, review feedback, close batch logs",
  //   ],
  // },
];

const AddLabourTrainning = () => {
  let userData = useSelector((store) => store.login.user);
  const [loading, setLoading] = useState(false);
  const [project, setProjects] = useState([]);
  const navigate = useNavigate();
  const [isHandOverCompleted, setIsHandOverCompleted] = useState(false);
  const [data, setData] = useState({});

  useEffect(() => {
    performRequest("GET", "/handOver/getHandOver/")
      .then((res) => {
        if (res.status === 200) {
          if (res?.data?.handOverData?.length > 0) {
            setIsHandOverCompleted(true);
          } else {
            setIsHandOverCompleted(false);
          }
        } else {
          Toast("error", "Error while getting data!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, []);

  useEffect(() => {
    setLoading(true);
    performRequest(
      "GET",
      getFilteredURL("/labourTraining/getlabourTraining/", 1, "filters")
    )
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
        } else {
          Toast("error", "Error while getting Data!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    performRequest("GET", "/siteInspection/getAllProjects")
      .then((res) => setProjects(res.data))
      .catch((err) => CustomErrorResponse(err));
  }, [userData]);

  const handleSubmit = (values, actions) => {
    if (values.labourSchedule?.length < 1) {
      Toast("error", "schedule not generated!");
      return;
    }
    if (userData?.Role === process.env.REACT_APP_ROLE_CLIENT) {
      let dt = project?.filter((el) => el.clientEmail === userData.Email);
      values = {
        ...values,
        clientProjectNumber: getId(dt[0]?.cpNumber),
      };
    }
    values = {
      ...values,
      clientProjectNumber: +values?.clientProjectNumber,
    };

    if (!values.clientProjectNumber) {
      Toast("error", "Client data not found!");
    } else {
      setLoading(true);
      performRequest("POST", "/labourTraining/createLabourTraining/", values)
        .then((res) => {
          if (res.status === 201) {
            Toast("success", "Labour tranining schedule created successfully!");
            navigate(`/labour-training`);
          } else {
            Toast("error", "Error while creating schedule");
          }
        })
        .catch((err) => {
          CustomErrorResponse(err);
        })
        .finally(() => setLoading(false));
    }
  };

  const generateDateLabels = (startdate) => {
    const schedule = [];
    for (let i = 0; i < trainingData.length; i++) {
      const date = new Date(startdate);
      date.setDate(date.getDate() + i);
      let data = trainingData[i]?.activities;
      for (let activity of data) {
        schedule.push({
          date: date.toISOString().split("T")[0],
          day: trainingData[i].day,
          activity,
          work: trainingData[i].work,
          activityDone: false,
          activityDoneDate: "",
        });
      }
    }

    return schedule;
  };

  if (loading) {
    return <LoadingPage />;
  }

  if (!isHandOverCompleted && data?.labourTrainingCount >= 1) {
    navigate("/labour-training/");
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xxl">
          <div className="page-header d-print-none">
            <div className="row align-items-center">
              <div className="col-md-8">
                <h2 className="page-title mb-1">
                  <FcReadingEbook
                    className="fs-2 me-1"
                    style={{ color: "green" }}
                  />{" "}
                  Labour Training
                </h2>
                <h4 className="text-muted">
                  Track & manage your training progress.
                </h4>
              </div>
              <div className="col-md-4">
                <div className="btn-list justify-content-end">
                  <a href={"/labour-training/"} className="btn btn-primary">
                    <FcReadingEbook className="fs-3 me-2" /> All Data
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="row col-12">
            <div className="card">
              <Formik
                initialValues={labourTrainingInfo}
                validationSchema={labourTrainingSchema}
                onSubmit={handleSubmit}
              >
                {(props) => (
                  <Form>
                    <div className="card-body">
                      {userData?.Role !== process.env.REACT_APP_ROLE_CLIENT && (
                        <div className="mb-3 row">
                          <label className="w-25 form-label required col-3">
                            Client name
                          </label>
                          <div className="w-100 col">
                            <CustomSelect
                              type="text"
                              name="clientProjectNumber"
                            >
                              <option value="">Select</option>
                              {project?.map((cl) => (
                                <option key={cl.id} value={getId(cl.cpNumber)}>
                                  {cl.clientName}
                                </option>
                              ))}
                            </CustomSelect>
                            {props.touched.clientProjectNumber &&
                              props.errors.clientProjectNumber && (
                                <p className="text-danger">
                                  {props.errors.clientProjectNumber}
                                </p>
                              )}
                          </div>
                        </div>
                      )}
                      <div className="mb-3 row">
                        <label className="w-25 form-label required col-3">
                          Labour name
                        </label>
                        <div className="w-100 col">
                          <CustomInput name="labourName" type="text" />
                          {props.touched.labourName &&
                            props.errors.labourName && (
                              <p className="text-danger">
                                {props.errors.labourName}
                              </p>
                            )}
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <label className="w-25 form-label col-3 required">
                          Training start date
                        </label>
                        <div className="w-100 col">
                          <CustomInput
                            name="startDate"
                            type="date"
                            disabled={props.values?.labourSchedule?.length > 0}
                          />
                          {props.touched.startDate &&
                            props.errors.startDate && (
                              <p className="text-danger">
                                {props.errors.startDate}
                              </p>
                            )}
                        </div>
                      </div>

                      <FieldArray name="labourSchedule">
                        {({ push, remove }) => (
                          <div>
                            {props.values?.labourSchedule?.length > 0 && (
                              <table className="fs-5 table table-vcenter table-striped">
                                <thead>
                                  <tr>
                                    <th>Day</th>
                                    <th>Date</th>
                                    <th>Activity</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {props.values?.labourSchedule?.map(
                                    (schedule, index) => {
                                      return (
                                        <tr key={index}>
                                          <td>
                                            {schedule.day} - {schedule.work}
                                          </td>
                                          <td>{schedule.date}</td>
                                          <td>{schedule.activity || "---"}</td>
                                        </tr>
                                      );
                                    }
                                  )}
                                </tbody>
                              </table>
                            )}

                            <button
                              className="btn btn-primary mt-4"
                              type="button"
                              disabled={
                                props.values?.labourSchedule?.length > 0
                              }
                              onClick={() => {
                                if (
                                  !props.values.labourName ||
                                  !props.values.startDate
                                ) {
                                  Toast(
                                    "error",
                                    "Please fill all the required fields before generating the schedule."
                                  );
                                  return;
                                }
                                const schedule = generateDateLabels(
                                  props.values.startDate
                                );
                                props.setFieldValue("labourSchedule", schedule);
                              }}
                            >
                              Generate schedule
                            </button>
                          </div>
                        )}
                      </FieldArray>
                    </div>
                    <div className="card-footer">
                      <div className="btn-list justify-content-end">
                        <FormSubmitButton buttonText="Create  schedule" />
                        <SimpleButton buttonText="Cancel" type="secondary" />
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default AddLabourTrainning;
